module.exports = __webpack_public_path__ + "assets/img/KeyReport_Rebai.7bc3417a-ps.jpg";